import React from 'react';
import { ShowIf } from 'src/components';
import { ConfirmModal } from 'src/features/common';
import { Address } from './address-summary-card';
import { DeleteIcon } from 'src/assets/images';
import { PencilLight as Pencil, CloseIconDark as Close } from 'src/assets/images';

interface IAddressItem {
  address: Address;
  automationid: string | undefined;
}

export const AddressItem = (props: IAddressItem) => {
  const [confirmModalVisible, setConfirmModalVisible] = React.useState(false);

  return (
    <article className="content-box broker-login">
      <ConfirmModal
        visible={confirmModalVisible}
        heading="Reduce quantity?"
        subtext="This will remove devices from your delivery addresses starting from the last added address."
        onCancel={() => setConfirmModalVisible(false)}
        onConfirm={() => {
          setConfirmModalVisible(false);
          props.address.onDeleteButtonClicked();
        }}
      />

      <section className={'full-row'}>
        <div className="heading-container">
          <p className="address-heading">{props.address.heading}</p>
          {props.address.isDeleteButtonEnabled && (
            <>
              {' | '}
              <img
                onClick={() => setConfirmModalVisible(true)}
                alt="remove-address"
                src={DeleteIcon}
              />
            </>
          )}
          {props.address.sideNote && <p>{props.address.sideNote}</p>}
        </div>
        <aside className="img-box">
          <ShowIf condition={props.address.isEditButtonEnabled}>
            <img
              src={Pencil}
              alt="Edit"
              onClick={props.address.onEditButtonClicked}
              automationid={`${props.automationid}_Edit_Address`}
            />
          </ShowIf>
          <ShowIf condition={props.address.isDeleteButtonEnabled}>
            <img
              id="close-icon"
              src={Close}
              alt="X"
              onClick={() => setConfirmModalVisible(true)}
              automationid={`${props.automationid}_Remove_Address`}
            />
          </ShowIf>
        </aside>
      </section>

      <>
        <section className="full-row address-columns">
          <section>
            <div>
              <p className="mini-heading">Address</p>
              <p>{props.address.addressLines.join(', ')}</p>
            </div>

            {props.address.tradingName && (
              <div>
                <p className="mini-heading">Trading Name</p>
                <p>{props.address.tradingName}</p>
              </div>
            )}

            <div>
              <p className="mini-heading">Recipient name</p>
              <p>{props.address.contact.name}</p>
            </div>
          </section>

          <section>
            <div>
              <p className="mini-heading">Recipient ID number</p>
              <p>{props.address.contact.id}</p>
            </div>

            <div>
              <p className="mini-heading">Recipient cell number</p>
              <p>{props.address.contact.cellNumber}</p>
            </div>

            {props.address.contact.workNumber && (
              <div>
                <p className="mini-heading">Recipient work number</p>
                <p>{props.address.contact.workNumber}</p>
              </div>
            )}
          </section>

          <section>
            <div>
              <p className="mini-heading">Devices</p>
              <p>{props.address.productDetails.devices}</p>
            </div>

            <div>
              <p className="mini-heading">Number of devices</p>
              <p>{props.address.productDetails.quantity}</p>
            </div>
          </section>
        </section>
      </>
    </article>
  );
};
